var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIconShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 80,
    viewBox: "0 0 66 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_419_1061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.755 34.674c3.485 2.383 3.485 7.524 0 9.907L17.386 70.126C13.404 72.849 8 69.997 8 65.174V14.08c0-4.824 5.404-7.676 9.386-4.953l37.369 25.546z",
    stroke: "#fff",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_419_1061",
    x: 0,
    y: 0.063,
    width: 65.369,
    height: 79.13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_419_1061"
  })))));
}
SvgPlayIconShadow.displayName = 'PlayIconShadow';
export default SvgPlayIconShadow;